module.exports = __webpack_public_path__ + "img/3.1.ec4c3d85.png";